export const EdsColorWhite = '#FFFFFF';
export const EdsColorBlack = '#000000';
export const EdsColorTransparent = 'rgba(255, 255, 255, 0.01)';
export const EdsColorBrandLcLightGreen = '#1DB470';
export const EdsColorBrandLcDarkGreen = '#125B3A';
export const EdsColorBrandLcYellow = '#FFFA55';
export const EdsColorBrandLcRed = '#FF554C';
export const EdsColorBrandLcLightBlue = '#98CDFF';
export const EdsColorBrandLcDarkBlue = '#5C76F3';
export const EdsColorBrandLcOrange = '#F97248';
export const EdsColorBrandLcPink = '#FCBDBD';
export const EdsColorBrandLcBerry = '#CF92EC';
export const EdsColorBrandLcLightPurple = '#B7B5FF';
export const EdsColorBrandLcDarkPurple = '#8A80FF';
export const EdsColorNeutral100 = '#E6E2DE';
export const EdsColorNeutral150 = '#D8D4D1';
export const EdsColorNeutral200 = '#CCC9C6';
export const EdsColorNeutral250 = '#BCB9B6';
export const EdsColorNeutral350 = '#9B9997';
export const EdsColorNeutral450 = '#83827E';
export const EdsColorNeutral550 = '#6B6A64';
export const EdsColorNeutral650 = '#55554E';
export const EdsColorNeutral750 = '#3A3A37';
export const EdsColorNeutral800 = '#30302E';
export const EdsColorNeutral850 = '#242423';
export const EdsColorNeutral900 = '#181818';
export const EdsColorNeutral950 = '#0E0E0E';
export const EdsColorNeutral025 = '#FAF9F8';
export const EdsColorNeutral050 = '#F4F1EF';
export const EdsColorRed100 = '#F9DFDF';
export const EdsColorRed150 = '#F6CBCB';
export const EdsColorRed200 = '#FCBDBD';
export const EdsColorRed250 = '#FF9C99';
export const EdsColorRed350 = '#FF6962';
export const EdsColorRed450 = '#EA4941';
export const EdsColorRed550 = '#C4352D';
export const EdsColorRed650 = '#9D1F18';
export const EdsColorRed750 = '#760903';
export const EdsColorRed800 = '#610702';
export const EdsColorRed850 = '#4A0703';
export const EdsColorRed900 = '#330502';
export const EdsColorRed950 = '#230301';
export const EdsColorRed050 = '#FCF0F0';
export const EdsColorOrange100 = '#FFDCCA';
export const EdsColorOrange150 = '#FFC7AB';
export const EdsColorOrange200 = '#FFB38D';
export const EdsColorOrange250 = '#FFA070';
export const EdsColorOrange350 = '#E87F4A';
export const EdsColorOrange450 = '#D0622C';
export const EdsColorOrange550 = '#B8470F';
export const EdsColorOrange650 = '#92380C';
export const EdsColorOrange750 = '#672808';
export const EdsColorOrange800 = '#532006';
export const EdsColorOrange850 = '#401805';
export const EdsColorOrange900 = '#2B1003';
export const EdsColorOrange950 = '#1B0A02';
export const EdsColorOrange050 = '#FFEEE5';
export const EdsColorYellow100 = '#F6EE65';
export const EdsColorYellow150 = '#EDDE45';
export const EdsColorYellow200 = '#DFCC32';
export const EdsColorYellow250 = '#CDB825';
export const EdsColorYellow350 = '#B79F15';
export const EdsColorYellow450 = '#9B7F01';
export const EdsColorYellow550 = '#7E6701';
export const EdsColorYellow650 = '#625101';
export const EdsColorYellow750 = '#463901';
export const EdsColorYellow800 = '#392F01';
export const EdsColorYellow850 = '#2C2400';
export const EdsColorYellow900 = '#1D1800';
export const EdsColorYellow950 = '#100D01';
export const EdsColorYellow050 = '#FFFC83';
export const EdsColorGreen100 = '#C2ECD9';
export const EdsColorGreen150 = '#A1E1C4';
export const EdsColorGreen200 = '#7ED6AD';
export const EdsColorGreen250 = '#5CCB98';
export const EdsColorGreen350 = '#1DB470';
export const EdsColorGreen450 = '#19955D';
export const EdsColorGreen550 = '#177A4D';
export const EdsColorGreen650 = '#125B3A';
export const EdsColorGreen750 = '#0E442B';
export const EdsColorGreen800 = '#0B3622';
export const EdsColorGreen850 = '#082719';
export const EdsColorGreen900 = '#061D13';
export const EdsColorGreen950 = '#04110B';
export const EdsColorGreen050 = '#E0F5EC';
export const EdsColorBlue100 = '#D3EAFF';
export const EdsColorBlue150 = '#B8DDFF';
export const EdsColorBlue200 = '#98CDFF';
export const EdsColorBlue250 = '#88BBFA';
export const EdsColorBlue350 = '#7398FD';
export const EdsColorBlue450 = '#5C76F3';
export const EdsColorBlue550 = '#4D63CB';
export const EdsColorBlue650 = '#3C4D9D';
export const EdsColorBlue750 = '#2B3770';
export const EdsColorBlue800 = '#232D5B';
export const EdsColorBlue850 = '#1B2347';
export const EdsColorBlue900 = '#12172F';
export const EdsColorBlue950 = '#0B0D1B';
export const EdsColorBlue025 = '#F5FAFF';
export const EdsColorBlue050 = '#EEF7FF';
export const EdsColorPurple100 = '#F3E5FA';
export const EdsColorPurple150 = '#EAD1F6';
export const EdsColorPurple200 = '#E0BAF2';
export const EdsColorPurple250 = '#D5A2EE';
export const EdsColorPurple350 = '#C580E7';
export const EdsColorPurple450 = '#A765C7';
export const EdsColorPurple550 = '#8A50A7';
export const EdsColorPurple650 = '#6E3A88';
export const EdsColorPurple750 = '#562D69';
export const EdsColorPurple800 = '#452455';
export const EdsColorPurple850 = '#311A3C';
export const EdsColorPurple900 = '#25142E';
export const EdsColorPurple950 = '#190D1E';
export const EdsColorPurple050 = '#FBF5FD';
export const EdsColorOpacity10 = '0.10';
export const EdsColorOpacity20 = '0.20';
export const EdsColorOpacity30 = '0.30';
export const EdsColorOpacity40 = '0.40';
export const EdsColorOpacity50 = '0.50';
export const EdsColorOpacity60 = '0.60';
export const EdsColorOpacity70 = '0.70';
export const EdsColorOpacity80 = '0.80';
export const EdsThemeColorBackgroundAppHeader = '#FAF9F8';
export const EdsThemeColorBackgroundAppHeaderHover = '#F4F1EF';
export const EdsThemeColorBackgroundAppHeaderActive = '#F4F1EF';
export const EdsThemeColorBackgroundCheckbox = '#19955D';
export const EdsThemeColorBackgroundCheckboxHover = '#177A4D';
export const EdsThemeColorBackgroundCheckboxActive = '#125B3A';
export const EdsThemeColorBackgroundInput = '#FFFFFF';
export const EdsThemeColorBackgroundRadioButton = '#19955D';
export const EdsThemeColorBackgroundRadioButtonHover = '#177A4D';
export const EdsThemeColorBackgroundRadioButtonActive = '#125B3A';
export const EdsThemeColorBackgroundSkeleton = '#E6E2DE';
export const EdsThemeColorBackgroundSkeletonStripe = '#F4F1EF';
export const EdsThemeColorBackgroundTableRowStripe1 = '#FFFFFF';
export const EdsThemeColorBackgroundTableRowStripe2 = '#FAF9F8';
export const EdsThemeColorBackgroundTableRowSelected = '#F4F1EF';
export const EdsThemeColorBackgroundTabUnderline = '#19955D';
export const EdsThemeColorBackgroundVisualPageIndicator = '#E6E2DE';
export const EdsThemeColorBackgroundVisualPageIndicatorCurrent = '#19955D';
export const EdsThemeColorBackgroundUtilityBase1 = '#FFFFFF';
export const EdsThemeColorBackgroundUtilityBase2 = '#FFFFFF';
export const EdsThemeColorBackgroundUtilityBase3 = '#FAF9F8';
export const EdsThemeColorBackgroundUtilityContainer = '#FFFFFF';
export const EdsThemeColorBackgroundUtilityContainerHover = '#FAF9F8';
export const EdsThemeColorBackgroundUtilityContainerActive = '#F4F1EF';
export const EdsThemeColorBackgroundUtilityContainerSelected = '#FFFFFF';
export const EdsThemeColorBackgroundUtilityOverlayLowEmphasis =
  'rgba(250, 249, 248, 0.60)';
export const EdsThemeColorBackgroundUtilityOverlayHighEmphasis =
  'rgba(36, 36, 35, 0.80)';
export const EdsThemeColorBackgroundUtilityObjectSelected = '#19955D';
export const EdsThemeColorBackgroundUtilityDefaultNoEmphasis =
  'rgba(255, 255, 255, 0.00)';
export const EdsThemeColorBackgroundUtilityDefaultNoEmphasisHover = '#F4F1EF';
export const EdsThemeColorBackgroundUtilityDefaultNoEmphasisActive = '#E6E2DE';
export const EdsThemeColorBackgroundUtilityDefaultLowEmphasis = '#F4F1EF';
export const EdsThemeColorBackgroundUtilityDefaultLowEmphasisHover = '#E6E2DE';
export const EdsThemeColorBackgroundUtilityDefaultLowEmphasisActive = '#D8D4D1';
export const EdsThemeColorBackgroundUtilityDefaultMediumEmphasis = '#6B6A64';
export const EdsThemeColorBackgroundUtilityDefaultMediumEmphasisHover =
  '#55554E';
export const EdsThemeColorBackgroundUtilityDefaultMediumEmphasisActive =
  '#3A3A37';
export const EdsThemeColorBackgroundUtilityDefaultHighEmphasis = '#242423';
export const EdsThemeColorBackgroundUtilityDefaultHighEmphasisHover = '#30302E';
export const EdsThemeColorBackgroundUtilityDefaultHighEmphasisActive =
  '#3A3A37';
export const EdsThemeColorBackgroundUtilityInteractiveNoEmphasis =
  'rgba(250, 249, 248, 0.00)';
export const EdsThemeColorBackgroundUtilityInteractiveNoEmphasisHover =
  '#F4F1EF';
export const EdsThemeColorBackgroundUtilityInteractiveNoEmphasisActive =
  '#E6E2DE';
export const EdsThemeColorBackgroundUtilityInteractiveLowEmphasis = '#FAF9F8';
export const EdsThemeColorBackgroundUtilityInteractiveLowEmphasisHover =
  '#F4F1EF';
export const EdsThemeColorBackgroundUtilityInteractiveLowEmphasisActive =
  '#E6E2DE';
export const EdsThemeColorBackgroundUtilityInteractiveHighEmphasis = '#242423';
export const EdsThemeColorBackgroundUtilityInteractiveHighEmphasisHover =
  '#3A3A37';
export const EdsThemeColorBackgroundUtilityInteractiveHighEmphasisActive =
  '#55554E';
export const EdsThemeColorBackgroundUtilityCriticalNoEmphasis =
  'rgba(255, 255, 255, 0.00)';
export const EdsThemeColorBackgroundUtilityCriticalNoEmphasisHover = '#FCF0F0';
export const EdsThemeColorBackgroundUtilityCriticalNoEmphasisActive = '#F9DFDF';
export const EdsThemeColorBackgroundUtilityCriticalLowEmphasis = '#F9DFDF';
export const EdsThemeColorBackgroundUtilityCriticalLowEmphasisHover = '#F6CBCB';
export const EdsThemeColorBackgroundUtilityCriticalLowEmphasisActive =
  '#FCBDBD';
export const EdsThemeColorBackgroundUtilityCriticalHighEmphasis = '#C4352D';
export const EdsThemeColorBackgroundUtilityCriticalHighEmphasisHover =
  '#9D1F18';
export const EdsThemeColorBackgroundUtilityCriticalHighEmphasisActive =
  '#760903';
export const EdsThemeColorBackgroundUtilityFavorableLowEmphasis = '#C2ECD9';
export const EdsThemeColorBackgroundUtilityFavorableLowEmphasisHover =
  '#A1E1C4';
export const EdsThemeColorBackgroundUtilityFavorableLowEmphasisActive =
  '#7ED6AD';
export const EdsThemeColorBackgroundUtilityFavorableHighEmphasis = '#177A4D';
export const EdsThemeColorBackgroundUtilityFavorableHighEmphasisHover =
  '#125B3A';
export const EdsThemeColorBackgroundUtilityFavorableHighEmphasisActive =
  '#0E442B';
export const EdsThemeColorBackgroundUtilityWarningLowEmphasis = '#FFFC83';
export const EdsThemeColorBackgroundUtilityWarningLowEmphasisHover = '#F6EE65';
export const EdsThemeColorBackgroundUtilityWarningLowEmphasisActive = '#EDDE45';
export const EdsThemeColorBackgroundUtilityWarningHighEmphasis = '#CDB825';
export const EdsThemeColorBackgroundUtilityWarningHighEmphasisHover = '#B79F15';
export const EdsThemeColorBackgroundUtilityWarningHighEmphasisActive =
  '#9B7F01';
export const EdsThemeColorBackgroundUtilityInformationalLowEmphasis = '#F4F1EF';
export const EdsThemeColorBackgroundUtilityInformationalLowEmphasisHover =
  '#E6E2DE';
export const EdsThemeColorBackgroundUtilityInformationalLowEmphasisActive =
  '#D8D4D1';
export const EdsThemeColorBackgroundUtilityInformationalHighEmphasis =
  '#177A4D';
export const EdsThemeColorBackgroundUtilityInformationalHighEmphasisHover =
  '#125B3A';
export const EdsThemeColorBackgroundUtilityInformationalHighEmphasisActive =
  '#0E442B';
export const EdsThemeColorBackgroundUtilityDisabledNoEmphasis =
  'rgba(250, 249, 248, 0.00)';
export const EdsThemeColorBackgroundUtilityDisabledLowEmphasis = '#F4F1EF';
export const EdsThemeColorBackgroundUtilityDisabledMediumEmphasis = '#CCC9C6';
export const EdsThemeColorBackgroundUtilityInverseNoEmphasis =
  'rgba(250, 249, 248, 0.00)';
export const EdsThemeColorBackgroundUtilityInverseNoEmphasisHover =
  'rgba(250, 249, 248, 0.10)';
export const EdsThemeColorBackgroundUtilityInverseNoEmphasisActive =
  'rgba(250, 249, 248, 0.20)';
export const EdsThemeColorBackgroundUtilityInverseHighEmphasis = '#FFFFFF';
export const EdsThemeColorBackgroundUtilityInverseHighEmphasisHover = '#FAF9F8';
export const EdsThemeColorBackgroundUtilityInverseHighEmphasisActive =
  '#F4F1EF';
export const EdsThemeColorBackgroundUtilityInverseDisabled =
  'rgba(250, 249, 248, 0.50)';
export const EdsThemeColorBackgroundProgressBar = '#19955D';
export const EdsThemeColorBackgroundProgressBarContent = '#19955D';
export const EdsThemeColorBackgroundProgressBarTrack = '#E6E2DE';
export const EdsThemeColorBorderAppHeaderSeparator = '#CCC9C6';
export const EdsThemeColorBorderUtilityDefaultLowEmphasis = '#CCC9C6';
export const EdsThemeColorBorderUtilityDefaultLowEmphasisHover = '#BCB9B6';
export const EdsThemeColorBorderUtilityDefaultLowEmphasisActive = '#9B9997';
export const EdsThemeColorBorderUtilityDefaultMediumEmphasis = '#83827E';
export const EdsThemeColorBorderUtilityDefaultMediumEmphasisHover = '#6B6A64';
export const EdsThemeColorBorderUtilityDefaultMediumEmphasisActive = '#55554E';
export const EdsThemeColorBorderUtilityDefaultHighEmphasis = '#242423';
export const EdsThemeColorBorderUtilityDefaultHighEmphasisHover = '#3A3A37';
export const EdsThemeColorBorderUtilityDefaultHighEmphasisActive = '#55554E';
export const EdsThemeColorBorderUtilityInteractive = '#CCC9C6';
export const EdsThemeColorBorderUtilityInteractiveHover = '#BCB9B6';
export const EdsThemeColorBorderUtilityInteractiveActive = '#9B9997';
export const EdsThemeColorBorderUtilityInteractiveSecondary = '#177A4D';
export const EdsThemeColorBorderUtilityInteractiveSecondaryHover = '#125B3A';
export const EdsThemeColorBorderUtilityInteractiveSecondaryActive = '#0E442B';
export const EdsThemeColorBorderUtilityCritical = '#C4352D';
export const EdsThemeColorBorderUtilityCriticalHover = '#9D1F18';
export const EdsThemeColorBorderUtilityCriticalActive = '#760903';
export const EdsThemeColorBorderUtilityFavorable = '#177A4D';
export const EdsThemeColorBorderUtilityFavorableHover = '#125B3A';
export const EdsThemeColorBorderUtilityFavorableActive = '#0E442B';
export const EdsThemeColorBorderUtilityWarning = '#7E6701';
export const EdsThemeColorBorderUtilityWarningHover = '#625101';
export const EdsThemeColorBorderUtilityWarningActive = '#463901';
export const EdsThemeColorBorderUtilityInformational = '#3A3A37';
export const EdsThemeColorBorderUtilityInformationalHover = '#242423';
export const EdsThemeColorBorderUtilityInformationalActive = '#0E0E0E';
export const EdsThemeColorBorderUtilityDisabled = '#CCC9C6';
export const EdsThemeColorBorderUtilityFocus = '#19955D';
export const EdsThemeColorBorderUtilityInverse = '#FFFFFF';
export const EdsThemeColorBorderUtilityInverseDisabled =
  'rgba(250, 249, 248, 0.50)';
export const EdsThemeColorIconUtilityDefaultPrimary = '#3A3A37';
export const EdsThemeColorIconUtilityDefaultPrimaryHover = '#242423';
export const EdsThemeColorIconUtilityDefaultPrimaryActive = '#0E0E0E';
export const EdsThemeColorIconUtilityDefaultSecondary = '#6B6A64';
export const EdsThemeColorIconUtilityDefaultSecondaryHover = '#55554E';
export const EdsThemeColorIconUtilityDefaultSecondaryActive = '#3A3A37';
export const EdsThemeColorIconUtilityInteractivePrimary = '#242423';
export const EdsThemeColorIconUtilityInteractivePrimaryHover = '#3A3A37';
export const EdsThemeColorIconUtilityInteractivePrimaryActive = '#55554E';
export const EdsThemeColorIconUtilityInteractivePrimaryVisited = '#242423';
export const EdsThemeColorIconUtilityInteractiveSecondary = '#177A4D';
export const EdsThemeColorIconUtilityInteractiveSecondaryHover = '#125B3A';
export const EdsThemeColorIconUtilityInteractiveSecondaryActive = '#0E442B';
export const EdsThemeColorIconUtilityInteractiveSecondaryVisited = '#177A4D';
export const EdsThemeColorIconUtilityCritical = '#9D1F18';
export const EdsThemeColorIconUtilityCriticalHover = '#760903';
export const EdsThemeColorIconUtilityCriticalActive = '#4A0703';
export const EdsThemeColorIconUtilityFavorable = '#125B3A';
export const EdsThemeColorIconUtilityFavorableHover = '#0E442B';
export const EdsThemeColorIconUtilityFavorableActive = '#082719';
export const EdsThemeColorIconUtilityWarning = '#7E6701';
export const EdsThemeColorIconUtilityWarningHover = '#625101';
export const EdsThemeColorIconUtilityWarningActive = '#463901';
export const EdsThemeColorIconUtilityInformational = '#177A4D';
export const EdsThemeColorIconUtilityInformationalHover = '#125B3A';
export const EdsThemeColorIconUtilityInformationalActive = '#0E442B';
export const EdsThemeColorIconUtilityDisabledPrimary = '#CCC9C6';
export const EdsThemeColorIconUtilityDisabledSecondary = '#CCC9C6';
export const EdsThemeColorIconUtilityInverse = '#FFFFFF';
export const EdsThemeColorIconUtilityInverseDisabled =
  'rgba(250, 249, 248, 0.50)';
export const EdsThemeColorIconUtilityInverseInteractiveVisited = '#FFFFFF';
export const EdsThemeColorIconUtilityInverseCritical = '#FF6962';
export const EdsThemeColorIconUtilityInverseFavorable = '#1DB470';
export const EdsThemeColorIconUtilityInverseWarning = '#F6EE65';
export const EdsThemeColorIconUtilityInverseInformational = '#FFFFFF';
export const EdsThemeColorIconUtilityPlaceholder = '#6B6A64';
export const EdsThemeColorIconAppHeaderPrimary = '#3A3A37';
export const EdsThemeColorIconAppHeaderSecondary = '#6B6A64';
export const EdsThemeColorTextUtilityDefaultPrimary = '#3A3A37';
export const EdsThemeColorTextUtilityDefaultPrimaryHover = '#242423';
export const EdsThemeColorTextUtilityDefaultPrimaryActive = '#0E0E0E';
export const EdsThemeColorTextUtilityDefaultSecondary = '#6B6A64';
export const EdsThemeColorTextUtilityDefaultSecondaryHover = '#55554E';
export const EdsThemeColorTextUtilityDefaultSecondaryActive = '#3A3A37';
export const EdsThemeColorTextUtilityInteractivePrimary = '#242423';
export const EdsThemeColorTextUtilityInteractivePrimaryHover = '#3A3A37';
export const EdsThemeColorTextUtilityInteractivePrimaryActive = '#55554E';
export const EdsThemeColorTextUtilityInteractivePrimaryVisited = '#242423';
export const EdsThemeColorTextUtilityInteractiveSecondary = '#177A4D';
export const EdsThemeColorTextUtilityInteractiveSecondaryHover = '#125B3A';
export const EdsThemeColorTextUtilityInteractiveSecondaryActive = '#0E442B';
export const EdsThemeColorTextUtilityInteractiveSecondaryVisited = '#177A4D';
export const EdsThemeColorTextUtilityCritical = '#9D1F18';
export const EdsThemeColorTextUtilityCriticalHover = '#760903';
export const EdsThemeColorTextUtilityCriticalActive = '#4A0703';
export const EdsThemeColorTextUtilityFavorable = '#125B3A';
export const EdsThemeColorTextUtilityFavorableHover = '#0E442B';
export const EdsThemeColorTextUtilityFavorableActive = '#082719';
export const EdsThemeColorTextUtilityWarning = '#7E6701';
export const EdsThemeColorTextUtilityWarningHover = '#625101';
export const EdsThemeColorTextUtilityWarningActive = '#463901';
export const EdsThemeColorTextUtilityInformational = '#3A3A37';
export const EdsThemeColorTextUtilityInformationalHover = '#242423';
export const EdsThemeColorTextUtilityInformationalActive = '#0E0E0E';
export const EdsThemeColorTextUtilityDisabledPrimary = '#CCC9C6';
export const EdsThemeColorTextUtilityDisabledSecondary = '#CCC9C6';
export const EdsThemeColorTextUtilityInverse = '#FFFFFF';
export const EdsThemeColorTextUtilityInverseDisabled =
  'rgba(250, 249, 248, 0.50)';
export const EdsThemeColorTextUtilityInverseInteractiveVisited = '#FFFFFF';
export const EdsThemeColorTextUtilityInverseSecondary = '#BCB9B6';
export const EdsThemeColorTextUtilityPlaceholder = '#6B6A64';
export const EdsThemeColorTextAppHeaderPrimary = '#3A3A37';
export const EdsThemeColorTextAppHeaderSecondary = '#6B6A64';
export const EdsThemeColorTextHeadline = '#242423';
export const EdsThemeColorTextHighlightForeground = '#30302E';
